import { IonButton, IonContent, IonIcon } from '@ionic/react';
import { lockClosedOutline } from 'ionicons/icons';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PRIVACY_LINK, TERMS_LINK } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import './Security.scss';

export const ScreenSecurity: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Security',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <OnboardingPage className="onboarding-security">
      <IonContent scrollY={false}>
        <div className="description">
          <UiTypography className="description-icon" variant="headline-large">
            <IonIcon icon={lockClosedOutline} />
          </UiTypography>
          <OnboardingTitle>
            What happens in Dialogue, stays in Dialogue
          </OnboardingTitle>
          <OnboardingSubtitle>
            Dialogue prioritizes and protects your personal information
          </OnboardingSubtitle>
        </div>

        <UiTypography className="disclaimer" variant="body-small">
          We never disclose your information. By tapping on Continue, you agree
          with our
          <IonButton
            mode="ios"
            className="link"
            href={PRIVACY_LINK}
            target="_blank"
          >
            Privacy Policy
          </IonButton>{' '}
          and
          <IonButton
            mode="ios"
            className="link"
            href={TERMS_LINK}
            target="_blank"
          >
            Terms of Use
          </IonButton>
        </UiTypography>
      </IonContent>
      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingPage>
  );
};
